import { AxiosError } from "axios"
import { api } from '@/utils/api';

export const swrConfig = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  // here we allow an array like `["url", { config }]` to be passed as opposed to just a single string URL,
  // so we always parse the input as an array, then spread it as arguments -@roland
  fetcher: (urlOrParamsArray: string | any[]) => api.get.apply(this, Array.isArray(urlOrParamsArray) ? urlOrParamsArray : [urlOrParamsArray]).then((res) => res.data),
  onError: (error: AxiosError, key) => {
    if (error.status !== 403 && error.status !== 404) {
      // We can send the error to Sentry,
      // or show a notification UI.
      console.warn(key, error)
    }
  }
}